import * as React from "react";
import { SVGProps } from "react";

export const IconGoogleMeeting = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={17}
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 9.777v1.501c0 .343.276.621.617.621h1.491V9.777H4z"
      fill="#fff"
    />
    <path
      d="M4 6.57h2.108v3.208H4V6.569zM12.496 5.346l-1.348 1.111v3.484l1.354 1.117c.202.16.499.014.499-.245V5.586a.309.309 0 00-.505-.24z"
      fill="#fff"
    />
    <path d="M4 6.569h2.108V4.447L4 6.57z" fill="#fff" />
    <rect width={17} height={16.5} rx={3} fill="#1976D2" />
    <path
      d="M12.495 5.346l-1.347 1.111V5.068a.619.619 0 00-.618-.62H6.108L4 6.568v4.709c0 .343.276.621.617.621h5.913a.619.619 0 00.618-.62V9.94l1.353 1.117c.202.16.499.014.499-.245V5.586a.309.309 0 00-.505-.24zM9.09 9.778H6.108V6.569h2.983v3.209z"
      fill="#fff"
    />
    <path
      d="M9.09 8.173v1.604H6.107V11.9h4.423c.34 0 .617-.278.617-.62V9.94L9.09 8.173z"
      fill="#fff"
    />
    <path d="M11.147 9.941V6.458L9.09 8.173l2.057 1.768z" fill="#fff" />
    <path
      d="M10.53 4.447H6.107V6.57H9.09v1.604l2.057-1.715v-1.39a.619.619 0 00-.617-.62z"
      fill="#fff"
    />
  </svg>
);
